"use client";

import { storyblokEditable, ISbStoryData } from "@storyblok/react/rsc";
import { AlertCircle } from "lucide-react";
import Card from "@/components/Card";
import { EventGridStoryblok } from "@/component-types-sb";

interface EventGridClientProps {
  blok: EventGridStoryblok;
  initialQueryResult: {
    stories: ISbStoryData[];
    total: number;
  };
  startIndex: number;
}

const EventGridClient: React.FC<EventGridClientProps> = ({ blok, initialQueryResult, startIndex }) => {
  const events = initialQueryResult?.stories || [];

  if (!initialQueryResult) {
    return (
      <div
        {...storyblokEditable(blok)}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4 min-h-[200px] place-items-center"
      >
        <div className="col-span-full flex flex-col items-center justify-center text-red-500">
          <AlertCircle className="h-8 w-8 mb-2" />
          <p>Error loading events</p>
          <p className="text-sm text-gray-500">Unknown error</p>
        </div>
      </div>
    );
  }

  if (!events || events.length === 0) {
    return (
      <div {...storyblokEditable(blok)} className="p-6">
        <p>Momentan haben wir keine Events geplant!</p>
      </div>
    );
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4"
    >
      {events.slice(startIndex).map((event: ISbStoryData, index: number) => (
        <Card
          key={event.uuid}
          fullWidth={index === 0 && blok.first_fullwidth}
          blok={{
            component: "card",
            _uid: event.uuid,
            variant: "event",
            title: event.name,
            date: event.content.date,
            image: event.content.image,
            link: event.content?.link || undefined,
          }}
        />
      ))}
    </div>
  );
};

export default EventGridClient;
